import React from 'react';

import { Button, Text } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';

import { ExpandableDetailContext } from './ExpandableDetail';

interface ExpandableDetailTriggerProps {
  openText: string;
  closedText: string;
  css?: SystemStyleObject;
}

export const ExpandableDetailTrigger: React.FC<ExpandableDetailTriggerProps> = ({ openText, closedText, css }) => {
  const { isExpanded, toggleExpand } = React.useContext(ExpandableDetailContext);
  return (
    <Button css={css} variant="textPrimary" onClick={toggleExpand}>
      <Text variant="text50">{isExpanded ? openText : closedText}</Text>
    </Button>
  );
};
